import { render, staticRenderFns } from "./AboutUs.vue?vue&type=template&id=4f2ff382&scoped=true&"
import script from "./AboutUs.vue?vue&type=script&lang=js&"
export * from "./AboutUs.vue?vue&type=script&lang=js&"
import style0 from "./AboutUs.vue?vue&type=style&index=0&lang=css&"
import style1 from "./AboutUs.vue?vue&type=style&index=1&id=4f2ff382&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f2ff382",
  null
  
)

export default component.exports